import { Routes } from '@angular/router';
import { authGuard } from '@core/auth';
import { AppShellFacade } from './layouts/app-shell/app-shell.facade';
import { provideAppShellData } from './layouts/app-shell/provide-app-shell-data';
import { SignInPageComponent } from '@features/auth/presentation/pages/sign-in-page/sign-in-page.component';
import { SignInGuard } from '@features/auth/application/sign-in.guard';

export const routes: Routes = [
  {
    path: 'signin',
    component: SignInPageComponent,
    canActivate: [SignInGuard],
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: '',
    canActivate: [authGuard],
    providers: [AppShellFacade, provideAppShellData()],
    loadComponent: () =>
      import('./layouts/app-shell/app-shell.component').then((m) => m.AppShellComponent),
    children: [
      {
        path: '',
        loadChildren: () => import('./layouts/app-shell/routes').then((m) => m.appShellRoutes),
      },
    ],
  },
  {
    path: '**',
    redirectTo: '/dashboard',
  },
];
